<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconClose_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.634 11.766a.8.8 0 0 0 1.132-1.132L9.13 8l2.635-2.634a.8.8 0 0 0-1.132-1.132L8 6.87 5.366 4.234a.8.8 0 0 0-1.132 1.132L6.87 8l-2.635 2.634a.8.8 0 0 0 1.132 1.132L8 9.13l2.634 2.635Z"
        clip-rule="evenodd"
    />
</svg>
